import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      minHeight: '100vh',
      padding: '1rem',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '190px',
      flexWrap: 'nowrap',
      position: 'relative',
      backgroundImage: 'url(assets/img/background-atlas.jpg)',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',

      '&:before': {
        content: '""',
        position: 'absolute',
        inset: '0',
        backgroundColor: '#001E2D66',
      },

      '& > div:first-child': {
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
        '& > .MuiTypography-h1': {
          fontSize: '3.2rem',
          color: '#fff',
          letterSpacing: '0.1rem',
          fontWeight: 500,
        },

        '& > img': {
          marginLeft: '1rem',
        },
      },
    },
    cardContent: {
      zIndex: 100,
      width: '452px',
      height: '524px',
      padding: '3rem 4rem',

      '& > div > div': {
        marginBottom: '2rem',
        '& > .MuiTypography-h1': {
          fontSize: '4rem',
          marginLeft: '1rem',
        },
      },

      '& .MuiTypography-subtitle1': {
        marginBottom: '1.5rem',
      },

      '& form': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        '& .MuiFormControl-root': {
          width: '100%',
        },
      },

      '& a': {
        marginTop: '.8rem',
        '& .MuiTypography-body2': {
          color: `${theme.palette.text.secondary}`,
          fontWeight: 500,
        },
      },
    },
    submitButton: {
      marginTop: '1.8rem',
      width: '100%',
    },
    softwareVersion: {
      marginTop: '5rem',
      fontSize: '1.2rem',
    },
  }),
)
